import {
  runAfterFirstMounted,
  addGlobalUncaughtErrorHandler,
} from '@nio-fe/mate-qiankun';
import { actions } from './generateMicroProps';
import useMatestoreStore from '@/store/matestoreStore';
// 全局生命周期init
export function setupMicroAppGlobal() {
  addGlobalUncaughtErrorHandler((event) => {
    console.error('addGlobalUncaughtErrorHandler', event);
    const reg = /\[qiankun\]: Wrapper element for (.+?) is not existed!/;
    if (typeof event === 'object') {
      let message;
      if (event instanceof PromiseRejectionEvent) {
        message = event.reason.message;
      } else if (event?.message) {
        message = event.message;
      }
      if (reg.test(message)) {
        const microStore = useMatestoreStore();
        const match = message?.match(reg);
        if (match && match[1]) {
          let microName = match[1].replace(/\-e([0-9]+)/, '');
          microStore.setMicroAppErrored(microName);
        }
      }
    }
  });

  runAfterFirstMounted(() => {
    console.log('[MainApp] first app mounted');
  });
}

/**
 * qiankun setGlobalState
 * @TODO qiankun3，弃用GlobalState
 */
export function setGlobalState(data: any) {
  actions.setGlobalState(data);
}
